import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import SearchProductsForm from "./SearchProductsForm";
import RightModalLayout from "../../../../layouts/Modal/RightModalLayout";
import { SIDEBAR_ACTIONS } from "../../../../../constants/actionsConstants";

const SearchProductsModal = ({
  selectedProducts,
  addProducts,
  helpText
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Orders');

  const closeAction = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
      payload: {
        componentKey: 'SearchProductsModal'
      }
    });
  };

  return (
    <RightModalLayout
      closeAction={closeAction}
      title={t('search.title')}
      showBackButton
    >
      <SearchProductsForm
        selectedProducts={selectedProducts}
        onCancel={closeAction}
        addProducts={addProducts}
        helpText={helpText}
      />
    </RightModalLayout>
  );
};

export default SearchProductsModal;
